<template>
  <div>
    <v-layout>
      <v-row>
        <v-col
          md="0"
          lg="6"
          class="d-none d-sm-flex"
          style="margin:0;padding:0"
        >
          <v-img class="img-intersection" :src="images.BG" />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
          style="margin:0;padding:0 3rem;background:#f0f0f7"
        >
          <div style="position:relative;">
            <v-row align="center" justify="center" class="img-intersection">
              <v-col cols="12" sm="8" md="8">
                <v-img
                  align-center
                  justify-center
                  alt="Seed Logo"
                  class="app img mx-auto"
                  :src="images.logo"
                  transition="scale-transition"
                  width="120"
                />

                <v-alert type="error" v-model="erroralert">{{
                  errorMessage
                }}</v-alert>
                <v-alert type="info" color="#61803A" v-model="successalert">{{
                  successMessage
                }}</v-alert>
                <v-form class="form ml-3 mr-3 text-center">
                  <v-text-field
                    class="mt-4"
                    label="New Password"
                    name="login"
                    type="text"
                    autocomplete="off"
                    v-model="password"
                  />
                  <v-text-field
                    class="mt-4"
                    label="Confirm Password"
                    name="login"
                    type="text"
                    autocomplete="off"
                    v-model="cpassword"
                  />

                  <v-row>
                    <v-spacer />
                    <router-link to="/" class="mt-4 labelbold"
                      >Go to Login</router-link
                    >
                  </v-row>
                </v-form>

                <v-layout flex align-center justify-center>
                  <v-btn
                    class="login"
                    large
                    color="#6CC8A0"
                    align="center"
                    justify="center"
                    style="color:#fff!important"
                    @click="ChangePassword"
                    :loading="loading"
                    >Reset Password</v-btn
                  >
                </v-layout>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#2f9a61" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#fff"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import GlobalMixin from "./Mixins/GlobalMixin";
import enurl from "@/api/environment";
import axios from "axios";
export default {
  name: "resetPassword",
  mixins: [GlobalMixin],
  data() {
    return {
      email: "",
      uID: "",
      password: "",
      cpassword: "",
      images: {
        logo: require("@/assets/imgs/SeedIcon.png"),
        BG: require("@/assets/imgs/SignInImage.png")
      },
      url: enurl.apiUrl,
      errorMessage: "Please check your Password",
      successMessage: "Password Reset Successfully",
      dialog: false,
      loading: false,
      erroralert: false,
      successalert: false
    };
  },

  methods: {
    ChangePassword() {
      let self = this;

      self.dialog = true;
      self.successalert = false;
      self.erroralert = false;

      let password = self.password;
      let cpassword = self.cpassword;
      let uID = self.uID;
      let eMail = self.email;
      if (password == cpassword) {
        axios
          .post(
            `${self.url}/Login/ChangeNewPassword?UserID=${uID}&eMail=${eMail}&password=${password}`
          )
          .then(function(response) {
            let check = response.data.data;
            if (check) {
              self.successalert = true;
              setTimeout(function() {
                self.$router.push("/");
              }, 3000);
            } else {
              self.erroralert = true;
            }
            self.dialog = false;
          })
          .catch(function(error) {});
      } else {
        self.erroralert = true;
        self.dialog = false;
      }
    }
  },
  mounted: function() {
    let params = new URLSearchParams(location.search);
    let uid = params.get("UID");
    let email = params.get("mail");
    this.uID = uid;
    this.email = email;
  }
};
</script>

<style scoped>
.login {
  width: 14rem;
  margin-top: 3rem;
}
.forgetPass {
  font-size: 18px;
  margin-top: -2rem;
}
.form {
  min-width: 50%;
  margin-top: 3rem;
}
.img-intersection {
  width: 100%;
  height: 100vh;
  max-width: 100%;
}
.labelbold {
  font-weight: bold;
}
::v-deep .theme--light .v-label {
  color: #47484b !important;
  font-weight: bold;
}
</style>
